#import "../fragments/email-sequence-template-fragment.graphql"

mutation UpdateEmailSequenceTemplate($emailSequenceTemplate: EmailSequenceTemplateUpdateInput!) {
    emailSequenceTemplateUpdate(input: $emailSequenceTemplate) {
        emailSequenceTemplate {
            ...EmailSequenceTemplate
        }
    }
}
